import React from "react";

export function Logo({ size = 40, showText = true, textClass = "text-emerald-950", brandClass = "" }) {
  return (
    <div className="flex items-center gap-2.5">
      <div
        className="rounded-full bg-white overflow-hidden shrink-0 shadow-sm ring-1 ring-black/5"
        style={{ width: size, height: size }}
      >
        <img
          src="/logo.png"
          alt="Aarogya Assist logo"
          className="w-full h-full object-cover scale-110"
          data-testid="brand-logo"
        />
      </div>
      {showText && (
        <span className={`font-heading font-bold tracking-tight leading-none ${textClass} ${brandClass}`}>
          Aarogya Assist Chatbot
        </span>
      )}
    </div>
  );
}

export function Copyright({ className = "" }) {
  return (
    <p className={`text-xs text-zinc-400 ${className}`} data-testid="copyright">
      © {new Date().getFullYear()} Aarogya Innovate Pvt Ltd. All rights reserved.
    </p>
  );
}
